<template>
  <div tabindex="0" class="e-card">
    <div class="e-card-title">Edit Group Transaction</div>

    <div v-if="selectedInvoices.length">
      <div class="group-title">Invoice Details</div>
      <div class="card-group">
        <InvoiceTile
          v-for="invoice in selectedInvoices"
          :key="invoice.invoiceId"
          :invoice="invoice"
        />
      </div>
      <div class="group-title">Payment Details</div>
      <div class="form-card">
        <!-- <div class="group-title">Payment Details</div> -->
        <div class="form-card-content">
          <div class="content-item">
            <span class="item-label">Payment Type:</span>
            <div class="item-value">
              <ejs-dropdownlist
                :dataSource="paymentTypeOptions"
                v-model="paymentType"
              >
              </ejs-dropdownlist>
            </div>
          </div>
          <div class="content-item">
            <span class="item-label">Transaction Number:</span>
            <div class="item-value">
              <ejs-textbox v-model="transactionNumber" />
            </div>
          </div>
          <div class="content-item">
            <span class="item-label">Total Payment Amount:</span>
            <div class="item-value">
              <ejs-numerictextbox
                format="C2"
                :showSpinButton="false"
                v-model="totalPaymentAmount"
              />
            </div>
          </div>
          <div class="content-item">
            <span class="item-label">Payment Date (yyyy-mm-dd):</span>
            <div class="item-value">
              <ejs-datepicker v-model="paymentDate" format="yyyy-MM-dd" />
            </div>
          </div>
        </div>
        <div class="card-row">
          <div class="align-center-bottom">
            <ejs-button
              type="button"
              @click.native="onProcessPaymentClick"
              cssClass="e-info"
            >
              Process Payment
            </ejs-button>

            <ejs-button
              type="button"
              @click.native="onCancelClick"
              cssClass="e-danger"
            >
              Cancel
            </ejs-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="form-card">
        <div class="card-row">
          <div class="align-center-bottom">No invoices to display.</div>
        </div>
        <div class="card-row">
          <div class="align-center-bottom">
            <ejs-button
              type="button"
              @click.native="onCancelClick"
              cssClass="e-danger"
            >
              Cancel
            </ejs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import Vue from "vue";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { mapGetters } from "vuex";
import InvoiceTile from "../components/accounting-invoice-tile.vue";
import {
  FETCH_ACCOUNTING_PAYMENT_TYPES,
  PROCESS_INVOICE_GROUP,
} from "../store";

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(ButtonPlugin);

export default {
  name: "GroupTransactionEdit",
  components: {
    InvoiceTile,
  },
  data() {
    return {
      selectedInvoices: [],
      selectedInvoicesAmount: 0,
      datePaid: null,
      paymentTypeOptions: [],
      paymentType: "",
      totalPaymentAmount: 0,
      transactionNumber: "",
      paymentDate: null,
      paymentMethodOptions: [],
    };
  },
  async created() {
    this.paymentTypeOptions = await this.getPaymentTypes();
  },
  mounted() {
    // eslint-disable-next-line max-len
    this.selectedInvoices = this.accountingOpenInvoices.filter((i) => this.accountingSelectedInvoiceIds.includes(i.invoiceId));
    this.selectedInvoicesAmount = this.selectedInvoices.reduce(
      (sum, item) => sum + item.invoiceAmount,
      0,
    );
    this.totalPaymentAmount = this.selectedInvoicesAmount;
  },
  computed: {
    ...mapGetters({
      accountingOpenInvoices: "accountingOpenInvoices",
      accountingSelectedInvoiceIds: "accountingSelectedInvoiceIds",
    }),
  },
  methods: {
    async getPaymentTypes() {
      await this.$store.dispatch(FETCH_ACCOUNTING_PAYMENT_TYPES);

      const opts = this.$store.getters.accountingPaymentTypes.filter(
        (i) => i.toLowerCase() === "eft" || i.toLowerCase() === "cheque",
      );
      opts.unshift("");

      return opts;
    },
    onCancelClick() {
      this.$router.push("/accounting/manage-accounting");
    },
    isGroupDataValid() {
      const errorMessages = [];

      if (!this.paymentType) {
        errorMessages.push("Payment Type is required.");
      }
      if (!this.paymentDate) {
        errorMessages.push("Payment Date is required.");
      }
      if (!this.transactionNumber) {
        errorMessages.push("Transaction Number is required.");
      }
      if (this.totalPaymentAmount !== this.selectedInvoicesAmount) {
        errorMessages.push("Total Payment Amount is required.");
      }

      if (errorMessages.length > 0) {
        errorMessages.map((msg) => this.$parent.notificationToasts.push({
          title: "Error!",
          content: msg,
          cssClass: "e-toast-danger",
          timeOut: 5000,
        }));
        this.$parent.$refs.notifierRef.show();
      }
      return errorMessages.length === 0;
    },
    async onProcessPaymentClick() {
      if (!this.isGroupDataValid()) return;

      const data = {
        paymentType: this.paymentType,
        cancelRefundMetDate: this.paymentDate,
        transactionNumber: this.transactionNumber,
        autoRecoverySaveInvoices: this.selectedInvoices.map((i) => ({
          invoiceId: i.invoiceId,
        })),
      };

      try {
        await this.$store.dispatch(PROCESS_INVOICE_GROUP, { data });

        this.$parent.notificationToasts.push({
          title: "Success!",
          content: "Invoices grouped successfully.",
          cssClass: "e-toast-success",
          timeOut: 5000,
        });
      } catch (error) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: error.message,
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }

      this.$router.push("/accounting/manage-accounting");
    },
  },
};
</script>

<style scoped>
.card-group {
  margin: 8px;
}
.group-title {
  font-size: 1.2em;
  font-weight: 550;
  padding: 8px 24px;
  background-color: #f1f1f1;
  margin: 8px;
}
.form-card {
  border: 1px solid #333;
  border-radius: 8px;
  padding: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 8px;
}

.form-card-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  gap: 10px;
}

.content-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px 4px 8px;
  background-color: #fff;
  border-radius: 4px;
}

.card-row {
  padding: 4px;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
}

.item-label {
  color: #333;
  white-space: nowrap; /* Prevent text wrapping */
  font-weight: 600;
}

.item-value {
  color: #333;
  padding: 0 8px 0 8px;
  width: 100%;
}
</style>
